<template>
  <v-dialog v-model="showModal" max-width="800">
    <v-form ref="form" lazy-validation autocomplete="off">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ title }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" class="px-0" v-if="passoGerente != null">
                <v-select
                  id="select_aprovador_gerente"
                  name="select_aprovador_gerente"
                  item-text="nome"
                  item-value="id"
                  clearable
                  v-model="idGerente"
                  :rules="[rules.required]"
                  :items="passoGerente.usuarios"
                  :label="`${$tc('label.gerente_comercial', 1)} *`">
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" class="item-lista py-1">
                      <v-list-item-content>
                        <span>{{ item.nome }}</span>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" class="px-0"
                v-if="possuiPassoFornecedor"
                v-for="(passoFornecedor, index) in passosFornecedor"
                :key="index">
                <v-select
                  v-if="isPassoAprovadorAutorizado(passoFornecedor) || !passoFornecedor.indPossuiRepresentacaoConjunto"
                  :id="`select_aprovador_fornecedor-${index}`"
                  :name="`select_aprovador_fornecedor-${index}`"
                  item-text="nome"
                  item-value="id"
                  clearable
                  v-model="passoFornecedor.idFornecedorAprovador"
                  :rules="[rules.required]"
                  :items="passoFornecedor.usuarios"
                  :disabled="passoFornecedor.usuarios.length === 1"
                  :label="`${$tc('label.tipos_fornecedor.' + passoFornecedor.tipoFornecedor.toLowerCase(), 1)} *`">
                </v-select>
                <v-select
                  v-else
                  :id="`select_aprovador_fornecedor-${index}`"
                  :name="`select_aprovador_fornecedor-${index}`"
                  item-text="nomeGrupoERepresentantes"
                  item-value="id"
                  class="select-aprovador-fornecedor"
                  v-model="passoFornecedor.idGrupoRepresentacaoConjunto"
                  :rules="[rules.required]"
                  :items="passoFornecedor.gruposRepresentacaoConjunto"
                  :disabled="passoFornecedor.gruposRepresentacaoConjunto.length === 1"
                  :label="`${$tc('label.tipos_fornecedor.' + passoFornecedor.tipoFornecedor.toLowerCase(), 1)} *`">
                  <template v-slot:selection="{ item }">
                    <span>{{ item.nomeGrupoERepresentantes }}</span>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="cancela">{{ $t('label.cancelar') }}</v-btn>
          <v-btn color="primary darken-1" @click.native="confirma">{{ $t('label.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { copyObject } from '@/common/functions/helpers';

export default {
  name: 'PlanejamentoContratoFormUsuarioCondicional',
  data() {
    return {
      showModal: false,
      idGerente: undefined,
      passosFornecedor: [],
      passoGerente: null,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    possuiPassoFornecedor() {
      return this.passosFornecedor.length > 0;
    },
  },
  methods: {
    open(passosFornecedor, passoGerente) {
      this.idGerente = undefined;
      if (passosFornecedor && passosFornecedor.length) {
        this.passosFornecedor = copyObject(passosFornecedor);
      }
      if (passoGerente && passoGerente.idPasso) {
        this.passoGerente = copyObject(passoGerente);
      }
      this.verificaOpcoesUnicas();
      this.showModal = true;
    },
    cancela() {
      this.showModal = false;
      this.resetaModal();
    },
    confirma() {
      if (!this.$refs.form.validate()) return;
      const dadosCondicional = {
        passosFornecedor: [],
      };
      if (this.passoGerente != null && this.passoGerente.idPasso) {
        dadosCondicional.idPassoGerente = this.passoGerente.idPasso;
        dadosCondicional.idGerente = this.idGerente;
      }
      this.passosFornecedor.forEach((passo, index) => {
        dadosCondicional.passosFornecedor[index] = {
          idPasso: passo.idPasso,
          tipoFornecedor: passo.tipoFornecedor,
        };

        let idsFornecedoresAprovadores = [];

        if (this.isPassoAprovadorAutorizado(passo) || !passo.indPossuiRepresentacaoConjunto) {
          idsFornecedoresAprovadores = [passo.idFornecedorAprovador];
        } else {
          const grupoRepresentacaoConjuntoSelecionado = passo.gruposRepresentacaoConjunto
            .find((grupo) => grupo.id === passo.idGrupoRepresentacaoConjunto);
          idsFornecedoresAprovadores = grupoRepresentacaoConjuntoSelecionado.idsRepresentantesLegais;
          dadosCondicional.passosFornecedor[index].nomeGrupoRepresentacaoConjunto = grupoRepresentacaoConjuntoSelecionado.nomeGrupo;
          dadosCondicional.passosFornecedor[index].idGrupoRepresentacaoConjunto = grupoRepresentacaoConjuntoSelecionado.id;
        }

        dadosCondicional.passosFornecedor[index].idsFornecedoresAprovadores = idsFornecedoresAprovadores;
      });
      this.$emit('selecionarUsuarioAprovador', dadosCondicional);
      this.showModal = false;
      this.resetaModal();
    },
    isPassoAprovadorAutorizado(passoFornecedor) {
      return passoFornecedor.tipoFornecedor === 'APROVADOR_AUTORIZADO';
    },
    verificaOpcoesUnicas() {
      if (this.passoGerente != null && this.passoGerente.idPasso && this.passoGerente.usuarios.length === 1) {
        this.idGerente = this.passoGerente.usuarios[0].id;
      }

      this.passosFornecedor.forEach((passo) => {
        if ((this.isPassoAprovadorAutorizado(passo) || !passo.indPossuiRepresentacaoConjunto)
          && passo.usuarios.length === 1) {
          passo.idFornecedorAprovador = passo.usuarios[0].id;
        } else if (passo.gruposRepresentacaoConjunto.length === 1) {
          passo.idGrupoRepresentacaoConjunto = passo.gruposRepresentacaoConjunto[0].id;
        }
      });
    },
    resetaModal() {
      this.passosFornecedor = [];
      this.passoGerente = null;
    },
  },
};
</script>
<style lang="css">
.item-lista:hover{
   background-color: rgb(221, 220, 220);
   opacity: 0,5;
}
.select-aprovador-fornecedor input {
  display: none;
}
.select-aprovador-fornecedor span {
  white-space: inherit;
  padding: 5px 0;
}
</style>
